import {
  Box,
  Card,
  CardContent,
} from '@mui/material';
import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { SomeNode } from 'link-lib';
import { useTempRecord } from 'link-redux';

import useEntryPointFormProps from '../../components/Form/hooks/useEntryPointFormProps';
import EntryPointForm from '../../components/Form/EntryPointForm';
import teamGL from '../../../ontology/teamGL';

const AddressBulkForm = ({ entrypoint, selected, setSelected }: {entrypoint: SomeNode, selected:SomeNode[], setSelected: Dispatch<SetStateAction<SomeNode[]>> }) => {
  const [key, setKey] = useState(1);
  const closeForm = () => setSelected([]);
  const record = useTempRecord(
    teamGL.Visit, { [teamGL.addressIds.value]: selected }, [key]);
  const entryPointFormProps = useEntryPointFormProps(entrypoint, { onDone: closeForm });

  useEffect(() => {
    setKey((prev) => prev + 1);
  }, [selected]);

  return (
    <Box
      sx={{
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        position: 'sticky',
        width: '100%',
      }}
    >
      <Card
        sx={{
          minWidth: '250px',
          pointerEvents: 'initial', 
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
          }}
        >
          Verwerk
          {' '}
          {selected.length}
          {' '}
          adres
          {selected.length > 1 && 'sen'}
          <EntryPointForm
            {...entryPointFormProps}
            key={key.toString()}
            object={record}
            onCancel={closeForm}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default AddressBulkForm;
